import ListOfVendor from './vendor-list/ListOfVendor';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import CostomTooltip from '../../common/CostomTooltip';

const Vendors = () => {
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState<any>(null);
  const [vendorCount, setVendorCount] = useState(0);

  const getPlanDetail = () => {
    setTimeout(() => {
      const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
      if (subscriptionPlanDetail) {
        setSubscriptionData(JSON.parse(subscriptionPlanDetail));
      }
    }, 100);
  };

  useEffect(() => {
    getPlanDetail();
  }, [vendorCount, sessionStorage.getItem('planDetail')]);

  return (
    <div className="bg-[#1E1E1E] h-screen py-5 w-full overflow-y-auto px-6 flex flex-col gap-2.5 overflow-hidden">
      <div className={`flex items-center justify-between`}>
        <label className={`text-[16px] text-white font-medium `}>Vendors</label>
        <CostomTooltip
          text={`Your can't add more Vendor. Please upgrade to continue.`}
          position="left"
          isDisabled={
            subscriptionData?.data?.user_vendor_count >= subscriptionData?.data?.user_vendor_limit
          }
        >
          <div
            className="h-8 w-8 bg-[#006BEA] rounded-lg flex justify-center items-center cursor-pointer"
            onClick={() =>
              subscriptionData?.data?.user_vendor_count >= subscriptionData?.data?.user_vendor_limit
                ? null
                : navigate('add-vendor')
            }
          >
            <FaPlus className="h-4 w-4" />
          </div>
        </CostomTooltip>
      </div>

      <ListOfVendor setVendorCount={setVendorCount} />
    </div>
  );
};

export default Vendors;
